export default __webpack_public_path__ + "static/media/transfer.4a4a7093.svg";